export const GET_ALL_SETTINGS_LOADING_ID = "GET_ALL_SETTINGS_LOADING_ID";
